import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import 'moment/locale/es-mx';

registerLocaleData(localeEsMx, 'es-MX');

// Idioma de la app (ngx-translate) → locale de Angular (DatePipe) y de moment.
const LOCALES: Record<string, { angular: string; moment: string }> = {
  es: { angular: 'es-MX', moment: 'es-mx' },
  en: { angular: 'en-US', moment: 'en' },
};

/**
 * Mantiene las fechas en el idioma activo: cambia el locale global de moment
 * cada vez que cambia el idioma de ngx-translate y expone el locale de Angular
 * para los DatePipe.
 */
@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  constructor(private translate: TranslateService) {
    this.applyMomentLocale(this.currentLang);
    this.translate.onLangChange.subscribe(({ lang }) => this.applyMomentLocale(lang));
  }

  // Antes de que AppComponent lea el idioma guardado, se usa el del navegador:
  // es el mismo que elegirá si no hay ninguno guardado.
  get currentLang(): string {
    return this.translate.getCurrentLang() || this.browserLanguage();
  }

  /** Idioma soportado del navegador ('es' | 'en'), o 'en' si no es ninguno. */
  browserLanguage(): string {
    const browserLang = navigator.language.split('-')[0].toLowerCase();
    return LOCALES[browserLang] ? browserLang : 'en';
  }

  get angularLocale(): string {
    return this.localeFor(this.currentLang).angular;
  }

  private applyMomentLocale(lang: string): void {
    moment.locale(this.localeFor(lang).moment);
  }

  private localeFor(lang: string) {
    return LOCALES[lang] ?? LOCALES['es'];
  }
}
